import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitOfflineDialog',
  props: {
    loading: { type: Boolean },
    unitName: { default: 'this resource' }
  },
  emits: ['dismiss', 'update-status'],
  setup(__props: any, { emit }) {

const props = __props as { loading: boolean, unitName: string }





const warningDialogText = computed(
  () =>
    `Ensure there are no scheduled/active jobs for this resource. Notify the operator prior to setting ${props.unitName.trim()} offline.`
)

const handleDismiss = () => {
  emit('dismiss')
}
const setUnitStatusToOffline = () => {
  emit('update-status')
}

return { __sfc: true,props, emit, warningDialogText, handleDismiss, setUnitStatusToOffline }
}

})